// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nZ","checkbox":"n0","labelText":"n1","optText":"n2"};